<template>
    <address :class="['address', { maxWidth : orientation === 'vertical' }]">
        <component :class="['contributor', orientation]"
            :is="componentType"
            :to="'/creator/' + slug">
            <img :class="['avatar', size]"
                :alt="'Avatar of ' + name"
                :src="renderAvatar"/>
            <div class="details">
                <div class="text">
                    <span class="label" v-if="!!$slots.default"><slot/></span>
                    <span class="name">{{ name }}</span>
                </div>
                <time class="timeStamp"
                    v-if="uploadTime"
                    :datetime="convertDatetime">
                    {{ uploadTime.toDate() | moment("from", "now") }}
                </time>
            </div>
        </component>
    </address>
</template>

<script>
    export default {
        name: 'Contributor',
        props: {
            name: {
                type: String,
                required: true
            },
            avatar: {
                type: String,
                required: true
            },
            slug: {
                type: String
            },
            uploadTime: {
                type: Object
            },
            orientation: {
                type: String,
                default: 'horizontal',
                validator: type => ['horizontal','vertical'].includes(type)
            },
            size: {
                type: String,
                default: 'small',
                validator: type => ['small','large'].includes(type)
            }
        },
        computed: {
            componentType() {
                if(this.slug) {
                    return 'router-link'
                } else {
                    return 'div'
                }
            },
            convertDatetime() {
                let date = this.uploadTime.toDate()

                const year = date.getYear() + 1900
                const month = date.getMonth()
                const day = date.getDate()

                return year + '-' + month + '-' + day
            },
            renderAvatar() {
                if(this.avatar) {
                    return this.avatar
                } else {
                    return this.constants.defaults.avatar
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .address {
        font-style: initial;
    }

    .maxWidth {
        display: flex;
        width: 100%;
    }

    .contributor {
        display: flex;
        width: fit-content;
        align-items: center;
        transition: $transition-eio-20;
        border-radius: 1rem;
        padding: 0.25rem;

        &:focus {
            box-shadow: var(--shadow-focus-s);
            outline: 0;
        }

        &:active {
            transform: scale(0.98);
        }
    }

    .vertical {
        flex-direction: column;
        padding: 1rem 1.5rem;
        width: 100%;

        .avatar {
            margin: 0 0 1rem 0;
        }

        &:hover {
            background: var(--color-white-40);
        }
    }

    .text {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 1rem;
    }

    .avatar {
        object-fit: cover;
        display: block;
        margin-right: 1rem;
        background: var(--color-grey-200);
    }

    .small {
        height: 2rem;
        width: 2rem;
        border-radius: 0.75rem;
    }

    .large {
        height: 4rem;
        width: 4rem;
        border-radius: 1.5rem;
    }

    .details {
        display: flex;
        flex-direction: column;
    }

    .label {
        margin-right: 0.5rem;
        color: var(--color-white-important);
    }

    .name {
        font-size: 1.1rem;
        font-weight: 700;
        font-family: $font-secondary;
        color: var(--color-primary-500);
        white-space: nowrap;

        &:hover {
            color: var(--color-primary-700);
        }

        &:active {
            color: var(--color-primary-300);
        }
    }

    .level {
        padding: 0.15rem 0.5rem;
        border-radius: 0.5rem;
        font-family: $font-secondary;
        background: var(--color-blue-500-30);
        color: var(--color-brand-700);
    }

    .timeStamp {
        color: var(--color-grey-600);
        font-size: 0.875rem;
    }
</style>